<ng-template #receipt_icon_setting_config let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.seller">
        <div class="side_popup_header">
            <span>{{localService.languageContent.seller.receipt_icon_config}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
    </div>
    <div class="side_popup_body" style="margin: 10px;"
        [ngStyle]="{'height' : (localService.sideBarBodyHeight - 45) + 'px'}" *ngIf="data">
        <div *ngFor="let item of data;">
            <div class="row styled_row box"
                *ngIf="!searchLanguage || searchLanguage.length == 0 || item.v5.indexOf(searchLanguage) > -1">
                <div class="col-12">
                    <div>
                        <button class="button_icon icon_adjust" [disabled]="!(item.v3 && item.v3.length > 5)"
                            title="{{item.v2 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                            (click)="onActiveInactiveStatus(item.key)"
                            [ngStyle]="{'color': item.v2 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v2 == '1' ?
                            "toggle_on" : "toggle_off"}}</button>
                        <app-label [Text]="item.v4" />
                        <div class="action_container">
                            <button class="button_icon button_icon_color icon_adjust"
                                *ngIf="item.v3 && item.v3.length > 5"
                                title="{{localService.languageContent.seller.download_icon}}"
                                (click)="saveBase64AsImage(item.v3,item.v1)">file_download</button>
                            &nbsp;
                            <app-file-upload [Id]="elementIds.fileUpload + '_' + item.v1" (onFileUploaded)="onLoad()"
                                [forId]="item.v6" [forId2]="businessId" [fileUploadFor]="FileUploadFor.ReceiptIcon"
                                [topPosition]="6" />
                        </div>
                    </div>
                    <div *ngIf="item.key && item.key.length > 5">
                        <div class="row" style="width: 100%;">
                            <div class="col-4">
                                <input autocomplete="off" type="number" class="number"
                                    (keypress)="localService.isNumberOnly($event,numericConfig)"
                                    id="{{elementIds.width}}" [(ngModel)]="item.v7"
                                    placeholder="*{{localService.languageContent.seller.width}}"
                                    title="{{localService.languageContent.seller.width}}"
                                    [ngClass]="item.v7 ? 'en' : ''" />
                            </div>
                            <div class="col-4">
                                <input autocomplete="off" type="number" class="number"
                                    (keypress)="localService.isNumberOnly($event,numericConfig)"
                                    id="{{elementIds.height}}" [(ngModel)]="item.v8"
                                    placeholder="*{{localService.languageContent.seller.height}}"
                                    title="{{localService.languageContent.seller.height}}"
                                    [ngClass]="item.v8 ? 'en' : ''" />
                            </div>
                            <div class="col-4">
                                <button type="button" class="btn btn-secondary" [disabled]="!item.v7 || !item.v8"
                                    (click)="onAction(1,item.key)"
                                    style="width: 100%;">{{localService.languageContent.common.save}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="img_container" *ngIf="item.v3 && item.v3.length > 5">
                        <img [src]="item.v3"
                            [ngStyle]="{'width' :item.v7? (item.v7 + 'px') : 'fit-content','height' :item.v8? (item.v8 + 'px') : 'fit-content'}">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="side_popup_footer">
        <div class="row">
            <div class="col-12">
                <input autocomplete="off" type="text" style="margin-bottom: 10px;" [(ngModel)]="searchLanguage"
                    title="{{localService.languageContent.common.search}}" id="{{elementIds.search}}"
                    placeholder="{{localService.languageContent.common.search}}" />
                <div>
                    <span>{{localService.languageContent.seller.max_icon_size}}</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>